(function ($) {
  $.fn.accordion = function (options) {
    return this.each(function (index, element) {
      let $accordion = $(element);
      let settings = $.extend({
        multiselect: $accordion.hasClass('multi'),
        linkable: $accordion.hasClass('linkable')
      }, options);
      $accordion.on('click', '> li > .title', function (e) {
        let li = $(e.currentTarget).parent();
        if (li.hasClass('active')) {
          li.removeClass('active');
          li.find('> .content').hide();
        } else {
          if (!settings.multiselect) {
            // This accordion does not support having multiple
            // sections open at once
            let accordion = li.parent();
            accordion.find('> .active').removeClass('active');
            accordion.find('> .content').hide();
          }
          if (settings.linkable && !settings.multiselect) {
            window.location.hash = '#' + li.attr('id');
          }
          li.addClass('active');
          li.find('> .content').show();
        }
      });
    });
  };
})(jQuery);
(function ($) {
  $('ul.accordion').accordion();
  if (window.location.hash) {
    // Attempt to open the accordion item that matches the hash
    let link = $(window.location.hash);
    if (link.length > 0 && link.parent('.accordion')) {
      link.find('> .title').trigger('click');
    }
  }
})(jQuery);